import type { ReactNode } from 'react';

/** The one way the portal says a figure or feature is not available: the reason, in words. Never a zero, never a blank. */
export function Unavailable({ children }: { children: ReactNode }) {
  return (
    <p className="pp-unavailable">
      <strong>Not available yet.</strong> {children}
    </p>
  );
}

export function SyntheticBanner() {
  return (
    <div className="pp-synthetic" role="note">
      <strong>Synthetic Demo Data.</strong> Everything in this portal is made up for review. No real client, payroll or money is involved.
    </div>
  );
}
